import { useState } from "react";
import { Box, Button, Dialog, IconButton } from "@material-ui/core";
import ClearIcon from "@material-ui/icons/Clear";

import {
  QuoteAssumptions,
  LeadAssumptions,
  FeedInTariffRateFarmBusiness,
  FeedInTariffRateHome,
  FeedInTariffToken,
  LeadAssumptionsBusiness,
  LeadAssumptionsHomeFarm
} from "../../../../app/consts";
import { useStyles } from "../../quoteDetail.styles";
import { useBreakpoint } from "../../../../hooks/useBreakpoint";
import { EQuotePurchaserType } from "../../../../api/Types";
import { RootState } from "../../../../app/rootReducer";
import { useSelector } from "react-redux";

export const ViewAssumptions = () => {
  const classes = useStyles();
  const { quote, lead, solarReport } = useSelector((state: RootState) => state.quote);
  const [openAssumptions, setOpenAssumptions] = useState(false);
  const { isMoreThanSm } = useBreakpoint();

  var assumptions = QuoteAssumptions;

  if (lead) {
    assumptions = LeadAssumptions;
    if (solarReport?.purchaserType === EQuotePurchaserType.Business) {
      assumptions = assumptions.concat(LeadAssumptionsBusiness);
    } else {
      assumptions = assumptions.concat(LeadAssumptionsHomeFarm);
    }
  }
  return (
    <>
      <Box mt="20px">
        <Button className={classes.btnLink2} onClick={() => setOpenAssumptions(true)}>
          View Assumptions
        </Button>
      </Box>
      <Dialog
        open={openAssumptions}
        onClose={() => {
          setOpenAssumptions(false);
        }}
        aria-labelledby="Summary-dialog-title"
        maxWidth="md"
        fullWidth
      >
        <Box padding={"42px"}>
          <Box position={"absolute"} top="10px" right="20px">
            <IconButton
              onClick={() => {
                setOpenAssumptions(false);
              }}
            >
              <ClearIcon />
            </IconButton>
          </Box>
          <Box>
            {quote && (
              <Box
                fontSize={isMoreThanSm ? "16px" : "14px"}
                textAlign={isMoreThanSm ? "left" : "center"}
                fontWeight={400}
                mb="10px"
                color={isMoreThanSm ? "#4b5462" : "rgba(17, 21, 33, 0.65)"}
              >
                To achieve these results your location, the slope of your roof, and the system's orientation are all
                considered.
              </Box>
            )}

            <Box
              fontSize={isMoreThanSm ? "16px" : "14px"}
              textAlign={isMoreThanSm ? "left" : "center"}
              mb={"35px"}
              fontWeight={400}
              color={isMoreThanSm ? "#4b5462" : "rgba(17, 21, 33, 0.65)"}
            >
              The following assumptions were made when calculating your solar proposals figures:
            </Box>
          </Box>
          <Box width={"100%"} fontSize={"14px"} fontWeight={400} color={"rgba(17, 21, 33, 0.65)"}>
            {assumptions.map((item, idx) => (
              <Box mb="10px" key={idx}>
                {item.replaceAll(
                  FeedInTariffToken,
                  (quote?.purchaserType === EQuotePurchaserType.Home
                    ? FeedInTariffRateHome
                    : FeedInTariffRateFarmBusiness
                  ).toString()
                )}
              </Box>
            ))}
          </Box>
        </Box>
      </Dialog>
    </>
  );
};
